const translations_swe = {
  "same.but": "Stad &",
  different: "land",
  "whats.your.name": "Vad heter du?",
  "this.name.is.already.taken": "Namnet är redan taget",
  "you.must.have.a.name": "Du måste ha ett namn...",
  submit: "Ok",
  "how.to.play": "Instruktioner",
  instructions:
    "Deltagarna kommer överens om valfritt antal kategorier, till exempel:",
  "instructions.cont":
    'Sedan slumpas det fram en bokstav och då gäller det att komma på ett ord för varje kategori som börjar på bokstaven. För bokstaven H till exempel kan man skriva: Helsingborg, Haiti, Häst, Hovslagare. Beroende på spelinställningarna avslutas rundan antingen när en spelare trycker på "KLAR"-knappen eller när tidsgränsen har gått ut. ',
  "category.example.1": "Stad",
  "category.example.2": "Land",
  "category.example.3": "Djur",
  "category.example.4": "Yrke",
  scoring: "Poängräkning",
  "scoring.instructions":
    "För varje svar som börjar på rätt bokstav och stämmer in på kategorin får man 2 poäng. Om någon annan har skrivit samma ord dock, får ni båda bara 1 poäng istället. Så det lönar sig att försöka komma på unika svar! Tomma eller ogiltiga svar ger 0 poäng.",
  "scoring.example":
    "Poängen går att ändra manuellt efter varje runda om spelarna kommer överens om att den automatiska rättningen är fel. Här är ett exempel på en runda:",
  "scoring.example.explanation":
    "Grön färg betyder 2 poäng, blå 1 poäng och röd 0 poäng. Poängräkningen syns längst ned med poäng som tjänades in denna rundan inom parantes.",
  close: "Stäng",
  game: "Spel",
  join: "Gå med",
  "reconnect.as": "Hoppa in som",
  "start.new.game": "Starta nytt spel",
  "include.swedish.letters": "Ta med ÅÄÖ",
  "include.hard.letters": "Ta med WXZQ",
  "play.with.time.limit": "Spela med tidsgräns",
  "win.conditions": "Slutvillkor:",
  none: " Inga",
  "number.of.rounds": " rundor",
  "number.of.points": " poäng",
  "players.can.end.round": "Spelare kan avsluta rundan",
  "you.must.enter.a.valid.time.limit": "Du måste ange en korrekt tidsgräns!",
  "welcome.to.the.lobby.for.game": "VÄLKOMMEN TILL LOBBYN FÖR SPEL",
  players: "Spelare",
  categories: "Kategorier",
  options: "Inställningar",
  "add.another.category": "Lägg till en kategori",
  "write.a.category": "Skriv en kategori",
  delete: "Ta bort",
  start: "Starta",
  seconds: "sekunder",
  "seconds.left": "s kvar",
  done: "KLAR",
  "total.points": "Totala poäng",
  points: "poäng",
  ready: "Redo",
  "you.disconnected": "Du tappade uppkopplingen!",
  "please.reload.page": "Var vänlig ladda om sidan",
  "remove.from.game": "Ta bort från spelet",
  "do.you.really.want.to.remove": (name: string) =>
    `Vill du verkligen ta bort ${name} från spelet?`,
  "this.player": "den här spelaren",
  and: " och ",
  won: "vann",
  "first.to": "Först till",
  "no.hacking": "Nehedu det där går inte längre!",
  "no.alex": "Det namnet är numera svartlistat här",
  "non.alpha.character": "Specialtecken är inte tillåtna",
  "name.too.long": "Du har angett för många tecken",
};
export default translations_swe;
